import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import SupportIcon from "@mui/icons-material/Support";
import { IconButton } from "@mui/material";
import {
  ActionSheetMenu,
  ActionSheetMenuItem,
  ResponsiveActionSheetMenu,
} from "@shared/components/ActionSheetMenu";
import { useIntercomIntegration } from "@shared/services/intercom/useIntercomIntegration";
import { useUIStore } from "@store/ui.store";

export const PageMoreActions = () => {
  const intercom = useIntercomIntegration();
  const toggleSupportDialogMode = useUIStore(
    (state) => state.toggleSupportDialogMode,
  );

  const handleOpenSupportHome = () => {
    intercom.hide();
    toggleSupportDialogMode({ mode: "home" });
  };

  return (
    <ResponsiveActionSheetMenu
      renderTrigger={({ triggerRef, onClick, isSheet }) => (
        <IconButton
          ref={triggerRef}
          onClick={onClick}
          size="small"
          aria-label="More options"
          sx={
            isSheet
              ? { "&:focus": { backgroundColor: "transparent" } }
              : undefined
          }
        >
          <MoreHorizIcon />
        </IconButton>
      )}
    >
      {(closeMenu) => (
        <ActionSheetMenu>
          <ActionSheetMenuItem
            icon={<SupportIcon />}
            label="Support"
            onClick={() => {
              closeMenu();
              handleOpenSupportHome();
            }}
          />
        </ActionSheetMenu>
      )}
    </ResponsiveActionSheetMenu>
  );
};
